"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _default = (0, _createSvg.createSvg)('IconHourGlass', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M6,18 L6,16.218 L8.659,10.417 C8.78,10.152 8.78,9.848 8.659,9.583 L6,3.782 L6,2 L14,2 L14,3.782 L11.341,9.583 C11.22,9.848 11.22,10.152 11.341,10.417 L14,16.218 L14,18 L6,18 Z M16,18 C16.553,18 17,18.447 17,19 C17,19.553 16.553,20 16,20 L15,20 L5,20 L4,20 C3.447,20 3,19.553 3,19 C3,18.447 3.447,18 4,18 L4,16 C4,15.856 4.031,15.714 4.091,15.583 L6.65,10 L4.091,4.417 C4.031,4.286 4,4.144 4,4 L4,2 C3.447,2 3,1.553 3,1 C3,0.447 3.447,0 4,0 L5,0 L15,0 L16,0 C16.553,0 17,0.447 17,1 C17,1.553 16.553,2 16,2 L16,4 C16,4.144 15.969,4.286 15.909,4.417 L13.35,10 L15.909,15.583 C15.969,15.714 16,15.856 16,16 L16,18 Z M9.584,8.376 C9.782,8.673 10.218,8.673 10.416,8.376 L11.231,6.777 C11.453,6.445 11.215,6 10.815,6 L9.185,6 C8.785,6 8.547,6.445 8.769,6.777 L9.584,8.376 Z M10.7119,12.2217 C10.4829,11.5377 9.5169,11.5377 9.2879,12.2217 L7.5819,16.3417 C7.4739,16.6657 7.7149,16.9997 8.0559,16.9997 L11.9439,16.9997 C12.2849,16.9997 12.5259,16.6657 12.4179,16.3417 L10.7119,12.2217 Z'],
  params: {
    width: '20',
    height: '20'
  },
  height: 20,
  width: 20
})));

exports.default = _default;